import React, { useMemo } from "react";
import { compose } from "react-apollo";
import { Col, Row } from "reactstrap";

import { withQuery } from "containers/withQuery";

import { INVENTORY_ITEMS_QUERY, INVENTORY_QUANTITIES_QUERY } from "./stockMaterialsQueries";
import InventoryItem from "./InventoryItem";

const indexInventoryQuantities = (inventoryQuantities) => (
  inventoryQuantities.reduce((map, iq) => {
    const itemId = iq.inventoryItem.id;

    if (!map.has(itemId)) {
      map.set(itemId, {
        inventoryQuantity: 0,
        inventoryLocations: [],
      });
    }

    const entry = map.get(itemId);

    entry.inventoryQuantity += Number(iq.quantity);

    entry.inventoryLocations.push({
      id: iq.inventoryLocation.id,
      name: iq.inventoryLocation.name,
      inventoryQuantity: iq.quantity,
    });

    return map;
  }, new Map())
);

const buildInventoryItems = (inventoryItems, inventoryQuantities) => {
  const quantitiesIndex = indexInventoryQuantities(inventoryQuantities);

  return inventoryItems.map((item) => {
    const quantities = quantitiesIndex.get(item.id);

    return {
      ...item,
      inventoryQuantity: (quantities && quantities.inventoryQuantity) ? quantities.inventoryQuantity : 0,
      inventoryLocations: (quantities && quantities.inventoryLocations) ? quantities.inventoryLocations : [],
    };
  });
};

const InventoryItems = ({
  inventoryItems,
  inventoryQuantities,
}) => {
  const reducedItems = useMemo(
    () => buildInventoryItems(inventoryItems, inventoryQuantities),
    [inventoryItems, inventoryQuantities]
  );

  const renderInventoryItem = (inventoryItem) => (
    <Col
      key={inventoryItem.id}
      xl="3"
      lg="4"
      md="6"
      sm="12"
      align="center"
    >
      <InventoryItem {...inventoryItem} />
    </Col>
  );

  return (
    <Row>
      {reducedItems
        .filter(({ materialType }) => materialType !== "WATER")
        .map(renderInventoryItem)}
    </Row>
  );
};

export default compose(
  withQuery({ query: INVENTORY_ITEMS_QUERY }),
  withQuery({ query: INVENTORY_QUANTITIES_QUERY }),
)(InventoryItems);
